import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
} from "react";
import Config from "./config";

import Login from "./components/login";
import Home from "./components/home";
import Dashboard from "./components/home/views/dashboard";
import Calendar from "./components/home/views/calendar";
import SalesComponent from "./components/home/views/sales";
// import Sales from "./components/home/views/sales";
import Audit from "./components/home/views/audit";
import PDFReports from "./components/home/views/reports";
import Account from "./components/home/views/account";
import Group from "./components/home/views/group";
import User from "./components/home/views/user";
import ErrorPage from "./components/settings/error";
import Loader from "./components/settings/loader";
import View1 from "./components/home/elements/view1";
import Body from "./components/home/elements/body";
import Integrations from "./components/home/views/Integrations";
import ProtectedRoute from "./Wrapper";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [filterValue, setFilterValue] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [user, setUser] = useState({ state: false, data: null });
  const routes = useMemo(() => [
    { name: "Home", path: "/app/*", element: <Home /> },
    { name: "Login", path: "/login/*", element: <Login /> },
    // { name: "Body", path: "/app/*", element: <Body /> },
  ]);

  const components = useMemo(
    () => ({
      page: [
        {
          name: "Integrations",
          path: "integrations/*",
          element: <Integrations />,
          auth: true,
        },
        {
          name: "View",
          path: "view/:type/:id",
          element: <View1 />,
          auth: true,
        },
      ],
      setting: [
        { name: "Error", component: ErrorPage },
        { name: "Loader", component: Loader },
      ],
    }),
    []
  );

  const chimeraserv = useMemo(() => ({
    urlGet: Config.get,
    urlPost: Config.post,
    urlMozrest: Config.mozrest_webhook,
    urlQlub: Config.qlub_webhook,
    urlSubway: Config.subway_base,
    urlToken: Config.subway_token_url,
    urlAwsPusher: Config.subway_aws_pusher_url,
    urlInsightBackendReading: Config.insight_backend_reading_url,
    authToken: Config.auth_token,
    mfzId: Config.mfz_Id,
    subway_brakey: Config.Subway_braKey,
    Delivery_Channels_3PD: Config.Delivery_Channels_3PD,
    InRestaurant_Channels: Config.InRestaurant_Channels,
    qlubAuthKey: Config.qlubAuthKey,
  }));

  const appContextValue = {
    routes,
    components,
    chimeraserv,
    user,
    setUser,
    toggle,
    setToggle,
    ProtectedRoute,
    filterValue,
    setFilterValue,
  };
  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

// Custom Hook for easy access
export const useAppContext = () => useContext(AppContext);
